import {
  WorkAuthorizationStatusEnum,
  WorkAuthorizationStatusEnumSchema,
} from '@eigtech/restoration-types'
import { exhaustive } from 'exhaustive'
import { startCase } from 'lodash-es'

const partialWorkAuthStatusLabels: Partial<Record<WorkAuthorizationStatusEnum, string>> = {}

export const getWorkAuthStatusLabel = (status: WorkAuthorizationStatusEnum) =>
  partialWorkAuthStatusLabels[status] ?? startCase(status)

export const workAuthStatusLabels = Object.fromEntries(
  WorkAuthorizationStatusEnumSchema.options.map((key) => [key, getWorkAuthStatusLabel(key)])
) as Record<WorkAuthorizationStatusEnum, string>

export const getWorkAuthStatusColorScheme = (status: WorkAuthorizationStatusEnum) =>
  exhaustive(status, {
    completed: () => 'green',
    declined: () => 'red',
    expired: () => 'red',
    override_approved: () => 'green',
    recalled: () => 'orange',
    sent: () => 'blue',
    signed: () => 'green',
  })
